// import getConfig from 'next/config'
// const config  = getConfig();

let conf = {
  siteName: 'CreativeBooster-创意生产平台', // 站点名称
  logoPath: '/logo.ico', // 网站icon路径
  manifest: '/manifest.json',
  iconfont: '//g.meetsocial.com/t/5_1745584171728.js', // ad-web iconfont资源地址 https://icon.meetsocial.cn/projects/34
  canvaSdk: '//sdk.canva.cn/designbutton/v2/api.js', // 可画sdk
  tencentSdk: '//cdn-go.cn/aegis/aegis-sdk/latest/aegis.min.js', // 腾讯云监控
  defaultAvatar: '//static.creativebooster.com/common/avatar.webp', // 默认头像
  apiPrefix: '/api/', // 接口前缀
  layouts: [
    {
      name: 'primary',
      include: [/.*/],
      exclude: [
        // 不需要带顶部导航栏布局的页面
        /login/,
        /forgot/,
        /register/,
        /policy/,
        /cancel/,
        /agreement/,
        /user\/activation/,
        /graphic\/create/,
        /template\/create/,
        /template\/auth/,
        /template\/distribute/,
        /graphic\/edit/,
        /share\/works/,
        /creative\/hot/,
        /creative\/product/,
        /sso/,
        /welcome/,
        /canvas-authorization/,
      ],
    },
  ],
  unAuthPages: [
    // 无权限可以访问的页面
    '/',
    '/home',
    '/template',
    '/works',
    '/media/creative',
    '/data/diagnosis',
    '/agreement',
    '/policy',
    '/share/works',
    '/user/activation',
    '/creative/hot',
    '/creative/product',
    '/inspiration',
    '/inspiration/case',
    '/inspiration/template',
    '/sso',
    '/ai/playground',
    '/404',
    '/500',
  ],
  withHelpPage: [
    // 需要显示帮助中心和客服的页面
    '/home',
    '/works',
    '/collect',
    '/draft',
    '/my/info',
    '/my/account',
    '/media/authorization',
    '/finance/record',
  ],
  unRedirectPageWhenLogin: [
    // 登录后无需要重定向的页面
    '/inspiration',
    '/inspiration/case',
    '/inspiration/template',
    '/template',
    '/share/works',
    '/ai/playground',
  ],
  unRedirectWelcomePage: [
    // 无需重定向到引导页的页面
    '/template',
    '/template/create',
    '/template/auth',
    '/template/distribute',
    '/creative/hot',
    '/creative/product',
  ],
  unLoadingPage: [
    // 不需要loader的页面
    '/graphic/create',
    '/graphic/edit',
    '/creative/hot',
    '/creative/product',
    '/sso',
    '/welcome',
    '/canvas-authorization',
  ],
  unRedirectLandingPage: [
    // 无需重定向到落地页的页面
    '/share/works',
    '/policy',
  ],
  hideMenuList: ['/ai/designer', '/ai-generator', '/campaigns/new'],
  expires: 9999, // cookie 时效，js-cookie :天为单位
}

const SERVER_API_MAP = {
  dev: 'https://cmapi-dev.meetsocial.cn',
  test: 'https://cmapi-test.meetsocial.cn',
  pre: 'https://n-pre-cmapi.meetsocial.cn',
  prod: 'https://n-cmapi.meetsocial.cn',
}

if (Object.prototype.toString.call(global.process) === '[object process]') {
  // 服务端
  const {
    APP_ENV,
    SSO_HOST,
    DEVELOPMENT_SSO_HOST,
    // API_HOST,
    XZ_APP_HOST,
    AD_WEB_HOST,
    VE_WEB_HOST,
    GUN_CE_YUN_ID,
    CB_LANDING_PAGE_URL,
    SHARE_HOST,
  } = process.env
  conf = {
    ...conf,
    APP_ENV,
    SSO_HOST,
    DEVELOPMENT_SSO_HOST,
    API_HOST: SERVER_API_MAP[APP_ENV],
    XZ_APP_HOST,
    AD_WEB_HOST,
    VE_WEB_HOST,
    GUN_CE_YUN_ID,
    CB_LANDING_PAGE_URL,
    SHARE_HOST,
  }
} else {
  const {
    APP_ENV,
    SSO_HOST,
    DEVELOPMENT_SSO_HOST,
    API_HOST,
    AD_WEB_HOST,
    VE_WEB_HOST,
    XZ_APP_HOST,
    GUN_CE_YUN_ID,
    CB_LANDING_PAGE_URL,
    SHARE_HOST,
  } = window.APP_CONFIG
  conf = {
    ...conf,
    APP_ENV,
    SSO_HOST,
    DEVELOPMENT_SSO_HOST,
    API_HOST,
    XZ_APP_HOST,
    AD_WEB_HOST,
    VE_WEB_HOST,
    GUN_CE_YUN_ID,
    CB_LANDING_PAGE_URL,
    SHARE_HOST,
  }
}

module.exports = conf
